import { useMutation } from '@tanstack/react-query';

export default function useAgreeTerms() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async () => {
      const response = await fetch('/agent/api/iam/terms_agreement', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
      });
      if (!response.ok) {
        throw new Error('Failed to agree terms');
      }
      return response.status === 204;
    },
  });
}
